import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { skipWhile, switchMap, tap } from 'rxjs/operators';

import { AppState, selectAccountState } from 'src/app/core/reducers';
import { JwtService } from '../services/jwt.service';
import { isAuth } from '../store';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store<AppState>, private router: Router) {}

  /**
   * Test if user can activate view component
   * @method canActivate
   * @return {Observable<boolean>} whether user can activate view component
   */

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(selectAccountState),
      skipWhile((state) => state.isLoading),
      switchMap(() =>
        this.store.pipe(
          select(isAuth),
          tap((authed) => {
            if (!authed) {
              this.router.navigate(['/login']);
            }
          })
        )
      )
    );
  }
}
